import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const appConfigSchemaLiteral = {
  title: 'app_config',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    key: { type: 'string', maxLength: 100 },
    value: { type: 'string', maxLength: 5000 },
    owner_only: { type: 'boolean' },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'key', 'value', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'key', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(appConfigSchemaLiteral);
export type AppConfigDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const appConfigSchema: RxJsonSchema<AppConfigDocType> = appConfigSchemaLiteral;
